<template>
  <o-confirmation-view
    image="images/delijn-header.jpg"
    message="Je bestelling is met succes geregistreerd. Je ticket zal beschikbaar zijn in je ticketportefeuille van zodra de verwerking klaar is."
    nav-bar-title="De Lijn"
  />
</template>

<script>
import OConfirmationView from '@/components/OConfirmationView.vue'
export default {
  name: 'DeLijnConfirmation',
  components: {
    OConfirmationView
  }
}
</script>
